import { Box, Divider, Flex, Group, Skeleton, SkeletonProps, Stack } from '@mantine/core'

import coinTabsStyles from './Header/CoinTabs/styles.module.css'

const SKELETON_BORDER_RADIUS = '40px'

function SingleChipSkeleton(props: SkeletonProps) {
  return (
    <Skeleton
      h={{ base: '32px', midScale: '36px' }}
      w="92px"
      bdrs={SKELETON_BORDER_RADIUS}
      style={{ flexShrink: 0 }}
      {...props}
    />
  )
}

function SingleTableCellSkeleton(props: SkeletonProps) {
  return <Skeleton h="20px" bdrs={SKELETON_BORDER_RADIUS} {...props} />
}

function SingleEllipseSkeleton(props: SkeletonProps) {
  return <Skeleton w="24px" h="20px" bdrs={SKELETON_BORDER_RADIUS} {...props} />
}

const COIN_TABS_COUNT = 6
const OG_COIN_TABS_COUNT = 5

export function HeaderSkeleton({ isOGPrice }: { isOGPrice?: boolean }) {
  const tabCount = isOGPrice ? OG_COIN_TABS_COUNT : COIN_TABS_COUNT
  return (
    <Flex direction={{ base: 'column', midScale: 'row' }} justify="space-between" gap="16px">
      <Group className={coinTabsStyles.tabs}>
        {Array.from({ length: tabCount }).map((_, index) => (
          <SingleChipSkeleton key={index} />
        ))}
      </Group>
      {!isOGPrice && <SingleChipSkeleton />}
    </Flex>
  )
}

function TableRowSkeleton({ isTableHeader }: { isTableHeader?: boolean }) {
  return (
    <>
      <Group justify="space-between" wrap="nowrap">
        {/* Rank column */}
        <SingleEllipseSkeleton visibleFrom="midScale" />

        <SingleTableCellSkeleton flex={1} />
        <SingleTableCellSkeleton flex={1} />
        <SingleTableCellSkeleton flex={1} />

        <SingleTableCellSkeleton flex={1} visibleFrom="medium" />
        <SingleTableCellSkeleton flex={1} visibleFrom="medium" />
        <SingleTableCellSkeleton flex={1} visibleFrom="medium" />

        {/* Actions column */}
        {isTableHeader ? (
          <Box w="24px" visibleFrom="midScale" />
        ) : (
          <SingleEllipseSkeleton visibleFrom="midScale" />
        )}
      </Group>
      {isTableHeader && (
        <Divider my="12px" style={{ '--divider-color': 'var(--border-surface-default)' }} />
      )}
    </>
  )
}

const SKELETON_ROW_COUNT = 20

export function TableSkeleton() {
  return (
    <Box>
      <TableRowSkeleton isTableHeader />
      <Stack gap="32px" mt="12px">
        {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
          <TableRowSkeleton key={index} />
        ))}
      </Stack>
    </Box>
  )
}

export default function CoinsTableSkeleton({ isOGPrice }: { isOGPrice: boolean }) {
  return (
    <Stack gap="30px">
      <HeaderSkeleton isOGPrice={isOGPrice} />
      <TableSkeleton />
    </Stack>
  )
}
